import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import SnackBarJs from "../SnackBar.js";
import PropTypes from "prop-types";
import {
  TextInput,
  Select,
  Checkbox,
  Textarea,
  Button,
  Group,
} from "@mantine/core";
import mgaConstants from '../../constants/index.js'

// moved inside component to allow translation via `t()`
let manufacturerListAll = [];

const AddAsset = ({
  getDefaultAssetsAttributeList,
  addAssetPopupStatus,
  addStatus,
  isBessSeletedDefault,
  assetsType,
  manufacturerList,
  updatedAsset,
  onCloseAssetPopUp,
  onUpdateAsset,
  getAssetDetailsAttribute,
  projectTypes,
  assetAttributes,
  addAttributeToLibrary,
  handleAsset,
  handleAssetSelection,
  handleAssetAttribute,
  asset,
  handleEditAsset,
  handleOkEditAsset,
  handleCancelUpdateAsset,
  setIsExtendedLibrary,
  inputRefs,
  currentAvailableAttributes,
  setAssetDetailsEx,
  setCurrentAvailableAttributes,
  isAssetTypeDisabled
}) => {
  const { t } = useTranslation();
  const inActiveComments = t("library.inactiveComments");
  const dropDownOption = {};
  projectTypes?.forEach((item) => (dropDownOption[item] = false));
  const [loading, setLoading] = useState(true);

  const [newManufacturer, setNewManufacturer] = useState(false);
  const [assetDetails, setAssetDetails] = useState({
    assetId: 0,
    assetType: 2,
    assetName: "",
    manufacturer: "",
    communicationModel: "",
    version: "",
    assetInfo: "NA",
    imagePreviewUrl: null,
    imageLink: null,
    validated: true,
    comments: "",
    availability: "",
  });
  const [errorStatus, setErrorStatus] = useState({
    commentsErrorStatus: false,
    assetTypeErrorStatus: false,
    versionErrorStatus: false,
    communicationModelErrorStatus: false,
    manufacturerErrorStatus: false,
    assetInfoErrorStatus: false,
    availabilityErrorStatus: false,
  });

  const [snackBar, setSnackBar] = useState({ type: "", message: "" });

  const snackBarRef = useRef(null);

  useEffect(() => {
    setLoading(false);
    if (addStatus === false) {
      setAssetDetails((prevState) => ({
        ...prevState,
        assetId: updatedAsset?.assetId,
        assetInfo: updatedAsset?.assetInfo,
        validated: updatedAsset?.validated,
        version: updatedAsset?.version,
        manufacturer: updatedAsset?.manufacturer,
        communicationModel: updatedAsset?.communicationModel,
        assetName: updatedAsset?.assetName,
        assetType: updatedAsset?.type?.id,
        comments: updatedAsset?.comments,
        imagePreviewUrl: updatedAsset?.imageLink,
        imageLink: updatedAsset?.imageLink,
        availability: updatedAsset?.availability,
      }));
    }
    let manufacturerDataList = [];
    assetsType.map((assetTypeData) => {
      let manufacturerListNew = new Set(manufacturerList[assetTypeData.type]);
      manufacturerDataList[assetTypeData.id] = Array.from(manufacturerListNew);
      return null;
    });
    manufacturerListAll = manufacturerDataList;
    const bessSelectedDefault = isBessSeletedDefault
      ? assetsType[0]?.id
      : assetDetails.assetType;
    let filteredId = assetsType.filter(
      (assetTypeData) =>
        assetTypeData.id ===
        parseInt(
          addStatus === false ? updatedAsset?.type?.id : bessSelectedDefault ,10
        )
    );

    setAssetDetails((prevState) => ({
      ...prevState,
      assetName: filteredId?.[0]?.type,
      assetType: filteredId?.[0]?.id,
    }));

    getAssetDetailsAttribute(
      addStatus === false ? updatedAsset?.type?.id : bessSelectedDefault
    );
  }, []);

  useEffect(() => {
    if (!addStatus || !isAssetTypeDisabled) return;
    if (!currentAvailableAttributes || currentAvailableAttributes.length === 0)
      return;
    if (!setAssetDetailsEx || typeof setAssetDetailsEx !== "function") return;
    if (assetAttributes && assetAttributes.length > 0) return;

    setAssetDetailsEx((prev) => ({
      ...prev,
      assetAttributes: currentAvailableAttributes.map((type, index) => ({
        type,
        value: "0",
        isEdit: false,
        id: `auto-${type}-${index}`,
      })),
    }));
  }, [addStatus, isAssetTypeDisabled, currentAvailableAttributes, assetAttributes, setAssetDetailsEx]);

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setLoading(true);
    switch (name) {
      case "assetType":
        const filteredId = assetsType.filter(
          (assetTypeData) => assetTypeData.id === parseInt(value, 10)
        );
        await getDefaultAssetsAttributeList(
          filteredId?.[0]?.type || "Generator"
        );
        setAssetDetailsEx((prevState) => ({
          ...prevState,
          assetAttributes: [],
        }));

        setAssetDetails((prevState) => ({
          ...prevState,
          assetName: filteredId?.[0]?.type,
        }));
        setErrorStatus((prevState) => ({
          ...prevState,
          assetTypeErrorStatus: true,
        }));
        break;

      case "manufacturer":
        setErrorStatus((prevState) => ({
          ...prevState,
          manufacturerErrorStatus: true,
        }));
        break;

      case "communicationModel":
        setErrorStatus((prevState) => ({
          ...prevState,
          communicationModelErrorStatus: true,
        }));
        break;

      case "version":
        setErrorStatus((prevState) => ({
          ...prevState,
          versionErrorStatus: true,
        }));
        break;

      case "assetInfo":
        setErrorStatus((prevState) => ({
          ...prevState,
          assetInfoErrorStatus: true,
        }));
        break;

      case "comments":
        setErrorStatus((prevState) => ({
          ...prevState,
          commentsErrorStatus: true,
        }));
        break;

      default:
        break;
    }
    setAssetDetails((prevState) => ({
      ...prevState,

      [name]: value,
    }));
    setLoading(false);
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;

    setAssetDetails((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
    setIsExtendedLibrary(checked);
    if (checked === false) {
      setAssetDetails((prevState) => ({
        ...prevState,
        comments: inActiveComments,
      }));
    } else {
      setAssetDetails((prevState) => ({
        ...prevState,
        comments: "",
      }));
    }
  };


  const cancelPopup = () => {
    resetValues();
    onCloseAssetPopUp();
  };

  const resetValues = () => {
    setCurrentAvailableAttributes([]);
    setAssetDetails((prevState) => ({
      ...prevState,
      assetType: 2,
      assetName: "",
      manufacturer: "",
      communicationModel: "",
      version: "",
      assetInfo: "NA",
      imagePreviewUrl: null,
      imageLink: null,
      validated: true,
      comments: "",
      availability: "",
    }));
    setErrorStatus((prevState) => {
      return {
        ...prevState,
        commentsErrorStatus: false,
        assetTypeErrorStatus: false,
        versionErrorStatus: false,
        communicationModelErrorStatus: false,
        manufacturerErrorStatus: false,
        assetInfoErrorStatus: false,
        availabilityErrorStatus: false,
      };
    });
    setNewManufacturer(false);
  };

  const saveAsset = () => {
    setLoading(true);

    const hasEmptyAttribute = (assetAttributes || []).some(
      (attr) => !attr?.type || `${attr?.value ?? ""}`.trim() === ""
    );

    if (hasEmptyAttribute) {
      callSnackbar("error", t("library.error.attributesMandatory"));
      setLoading(false);
      return;
    }

    if (assetDetails.assetType == "") {
      callSnackbar("error", t("library.error.assetTypeMandatory"));
      setLoading(false);
    } else if (assetDetails.manufacturer.trim() === "") {
      callSnackbar("error", t("library.error.assetMakeMandatory"));
      setLoading(false);
    } else if (assetDetails.communicationModel.trim() === "") {
      callSnackbar("error", t("library.error.assetModelMandatory"));
      setLoading(false);
    }  else {
      let jsonData = {
        assetId: assetDetails.assetId,
        assetInfo: assetDetails.assetInfo,
        validated: assetDetails.validated,
        version: assetDetails.version,
        manufacturer: assetDetails.manufacturer,
        communicationModel: assetDetails.communicationModel,
        assetName: assetDetails.assetName,
        type: {
          id: assetDetails.assetType,
        },
        comments: assetDetails.comments,
      };
      onUpdateAsset(jsonData);
    }
  };

  const callSnackbar = useCallback((type, message) => {
    try {
      setSnackBar({ type, message });
      snackBarRef.current.open = true;
      if( type === "error" ){
        snackBarRef.current.canClose = true;
      }
    } catch (error) {
      console.log("error in snack bar");
    }
  }, []);

  // Handler to delete an attribute and update available attributes
  const handleDeleteAttribute = (attribute) => {
    if (!attribute?.type) return;
    // Remove from assetAttributes
    setAssetDetailsEx((prev) => ({
      ...prev,
      assetAttributes: prev.assetAttributes.filter(
        (attr) => attr.type !== attribute.type
      ),
    }));
    // Optionally, update currentAvailableAttributes if needed
    setCurrentAvailableAttributes((prev) => {
      if (!prev.includes(attribute.type)) {
        return [...prev, attribute.type];
      }
      return prev;
    });
  };

  return (
    <se-dialog
      id="dialog-complex"
      size="xlarge"
      open={addAssetPopupStatus}
      can-backdrop="false"
    >
      <se-dialog-header>
        {addStatus
          ? t("library.addAsset.addTitle")
          : t("library.addAsset.editTitle")}
      </se-dialog-header>

      <se-dialog-content className="se-dialog-content">
        <se-loading loading={loading}></se-loading>
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <Group align="flex-end" grow>
                    <Select
                      label={t("library.assetType")}
                      withinPortal
                      required
                      disabled={isAssetTypeDisabled}
                      placeholder={t("library.selectAssetType")}
                      data={assetsType.map((assetTypeData) => ({
                        value: assetTypeData.id.toString(),
                        label:
                          assetTypeData.type === "PV_inverter"
                            ? t("library.pvInverter")
                            : assetTypeData.type === "EV_charging_station"
                            ? t("library.evChargingStation")
                            : assetTypeData.type,
                      }))}
                      value={assetDetails.assetType?.toString()}
                      onChange={(value) =>
                        handleChange({ target: { name: "assetType", value } })
                      }
                      error={
                        parseInt(assetDetails.assetType, 10) <= 0 &&
                        errorStatus.assetTypeErrorStatus
                          ? t("library.assetType.required")
                          : undefined
                      }
                      searchable
                    />
                  </Group>
                </div>
                <div className="col-md-6 mb-3">
                  {/* {addStatus ? (
                      newManufacturer ? (
                        <Group align="flex-end" grow>
                          <TextInput
                            label="Asset Manufacturer"
                            required
                            placeholder={t("library.enterNewManufacturer")}
                            maxLength={50}
                            value={assetDetails.manufacturer}
                            onChange={(e) => handleChange({ target: { name: 'manufacturer', value: e.currentTarget.value } })}
                            error={assetDetails.manufacturer.trim() === '' && errorStatus.manufacturerErrorStatus ? 'Asset Manufacturer is required.' : undefined}
                          />
                          <Button
                            variant="subtle"
                            color="green"
                            size="xs"
                            onClick={() => {
                              if (assetDetails.manufacturer.trim()) {
                                // Add new manufacturer to the list for the selected asset type
                                const typeId = parseInt(assetDetails.assetType);
                                if (manufacturerListAll[typeId] && !manufacturerListAll[typeId].includes(assetDetails.manufacturer.trim())) {
                                  manufacturerListAll[typeId].push(assetDetails.manufacturer.trim());
                                }
                                // Set the manufacturer value and switch back to dropdown
                                setAssetDetails((prevState) => ({
                                  ...prevState,
                                  manufacturer: assetDetails.manufacturer.trim(),
                                }));
                                setNewManufacturer(false);
                              }
                            }}
                            disabled={!assetDetails.manufacturer.trim()}
                            title={t("library.addManufacturer")}
                          >
                            <se-icon size="medium" color="primary">notification_ok_stroke</se-icon>
                          </Button>
                          <Button aria-label="library-cancel-new-manufacturer" variant="subtle" color="red" size="xs" onClick={enableNewManufacturer}>
                            <se-icon size="medium" color="primary">action_delete_cross</se-icon>
                          </Button>
                        </Group>
                      ) : (
                        <Select
                        withinPortal
                          label={t("library.assetManufacturer")}
                          required
                          placeholder={t("library.selectAssetManufacturer")}
                          data={manufacturerListAll[parseInt(assetDetails.assetType)]?.map((manufacturer) => ({ value: manufacturer, label: manufacturer })) || []}
                          value={assetDetails.manufacturer}
                          onChange={(value) => handleChange({ target: { name: 'manufacturer', value } })}
                          error={assetDetails.manufacturer.trim() === '' && errorStatus.manufacturerErrorStatus ? t("library.assetManufacturer.required") : undefined}
                          rightSection={
                              <Button aria-label="library-enable-new-manufacturer" variant="subtle" color="blue" size="xs" onClick={enableNewManufacturer}>
                              <se-icon size="medium" color="primary">action_editor</se-icon>
                            </Button>
                          }
                        />
                      )
                    ) :  */}

                  <TextInput
                    label={t("library.assetManufacturer")}
                    required
                    placeholder={t("library.assetManufacturer")}
                    maxLength={50}
                    value={assetDetails.manufacturer}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "manufacturer",
                          value: e.currentTarget.value,
                        },
                      })
                    }
                    error={
                      assetDetails.manufacturer.trim() === "" &&
                      errorStatus.manufacturerErrorStatus
                        ? t("library.assetManufacturer.required")
                        : undefined
                    }
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <TextInput
                    label={t("library.assetModel")}
                    required
                    placeholder={t("library.assetModel")}
                    maxLength={50}
                    value={assetDetails.communicationModel}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "communicationModel",
                          value: e.currentTarget.value,
                        },
                      })
                    }
                    error={
                      assetDetails.communicationModel.trim() === "" &&
                      errorStatus.communicationModelErrorStatus
                        ? t("library.assetModel.required")
                        : undefined
                    }
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <TextInput
                    label={t("library.version")}
                    placeholder={t("library.version")}
                    maxLength={10}
                    value={assetDetails.version}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "version",
                          value: e.currentTarget.value,
                        },
                      })
                    }
                  />
                </div>
                <div className="col-md-6 mb-3">
                    <Select
                    withinPortal
                      label={t("library.communicationModel")}
                      placeholder={t("library.communicationModel")}
                      data={["NA","Hardwired", "Communicating", "Serial"].map((v) => ({
                      value: v,
                      label: t(`library.assetInfo.${v}`),
                    }))}
                    value={assetDetails.assetInfo || "NA"}
                    onChange={(value) =>
                      handleChange({
                        target: { name: "assetInfo", value: value || "NA" },
                      })
                    }
                  />
                </div>
                {/* <div className="col-md-6 mb-3">
                  <label className="col-md-2 col-form-label mb-3"></label>
                  <Checkbox
                    name="validated"
                    label="Active"
                    checked={assetDetails.validated}
                    onChange={handleCheckBoxChange}
                  />
                </div> */}
                <div className="col-12 mb-3">
                  <label className="col-md-2 col-form-label">
                    {t("library.attributes")}
                  </label>
                  <div className="col-md-10">
                    {currentAvailableAttributes.length > 0 && (
                      <Group align="center" mb={8}>
                        <div className="row w-100">
                          <div className="col-sm-4">
                            <Select
                              withinPortal
                              placeholder={t("library.selectAttributeType")}
                              data={currentAvailableAttributes
                                .filter(
                                  (attributeType) =>
                                    !assetAttributes.some(
                                      (attr) => attr.type === attributeType
                                    )
                                )
                                .map((attributeType) => ({
                                  value: attributeType,
                                  label: mgaConstants?.assetLabels?.[attributeType] || attributeType,
                                }))}
                              value={asset?.type || ""}
                              onChange={(value) =>
                                handleAssetSelection({
                                  target: { name: "type", value },
                                })
                              }
                              searchable
                            />
                          </div>
                          <div className="col-sm-2">
                            <TextInput
                              placeholder={t("library.value")}
                              maxLength={10}
                              value={asset?.value || ""}
                              onChange={(e) =>
                                handleAsset({
                                  target: {
                                    name: "value",
                                    value: e.currentTarget.value,
                                  },
                                })
                              }
                            />
                          </div>
                          <div className="col-sm-4">
                            {asset?.type && asset?.value ? (
                              <Button
                                variant="subtle"
                                size="xs"
                                color="blue"
                                onClick={() =>
                                  addAttributeToLibrary(assetAttributes?.length)
                                }
                                disabled={!asset?.type || !asset?.value}
                                title={t("library.addAttribute")}
                                style={{
                                  flex: "none",
                                  width: 32,
                                  minWidth: 32,
                                  height: 32,
                                  minHeight: 32,
                                  padding: 0,
                                }}
                              >
                                <se-icon size="medium" color="primary">
                                  action_add_flat
                                </se-icon>
                              </Button>
                            ) : (
                              // Reserve space for the add icon when disabled
                              <div
                                style={{
                                  width: 32,
                                  minWidth: 32,
                                  height: 32,
                                  minHeight: 32,
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </Group>
                    )}
                    {assetAttributes?.length > 0 &&
                      assetAttributes.map((attribute, index) => (
                        <Group
                          key={attribute?.id || index}
                          mb={8}
                          align="center"
                        >
                          <div className="row w-100">
                            <div className="col-sm-4">
                              <TextInput
                                value={
                                  mgaConstants?.assetLabels?.[attribute?.type] ||
                                  attribute?.type
                                }
                                disabled
                                placeholder={t("library.attributeType")}
                                // style={{ flex: 1 }}
                              />
                            </div>
                            <div className="col-sm-2">
                              <TextInput
                                value={attribute?.value}
                                placeholder={t("library.attributeValue")}
                                name="value"
                                maxLength={10}
                                onChange={(e) =>
                                  handleAssetAttribute(e, attribute)
                                }
                                disabled={false}
                                ref={(el) => (inputRefs.current[index] = el)}
                                // style={{ flex: 1 }}
                              />
                            </div>
                            <div className="col-sm-4">
                              {attribute?.type !== "type" && (
                                <Button
                                  variant="subtle"
                                  size="xs"
                                  color="red"
                                  onClick={() => handleDeleteAttribute(attribute)}
                                  title={t("library.deleteAttribute")}
                                  style={{
                                    flex: "none",
                                    width: 32,
                                    minWidth: 32,
                                    height: 32,
                                    minHeight: 32,
                                    padding: 0,
                                  }}
                                >
                                  <se-icon size="small">action_delete</se-icon>
                                </Button>
                              )}
                            </div>
                          </div>
                        </Group>
                      ))}
                    
                  </div>
                </div>
                <div className="col-12 mb-3">
                  <Textarea
                    label={t("library.comments")}
                    placeholder={t("library.comments")}
                    minRows={3}
                    value={assetDetails.comments}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: "comments",
                          value: e.currentTarget.value,
                        },
                      })
                    }
                    error={
                      assetDetails.comments === "" &&
                      errorStatus.commentsErrorStatus
                        ? t("library.comments.required")
                        : undefined
                    }
                    disabled={!assetDetails.validated}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <SnackBarJs snackBar={snackBar} ref={snackBarRef} />
      </se-dialog-content>

      <se-dialog-footer>
        <se-button aria-label="library-add-asset-cancel" onClick={cancelPopup}>{t("common.cancel")}</se-button>

        <se-button aria-label="library-add-asset-save" color="primary" onClick={saveAsset}>
          {addStatus ? t("common.save") : t("profile.ok")}
        </se-button>
      </se-dialog-footer>
    </se-dialog>
  );
};

AddAsset.propTypes = {
  addAssetPopupStatus: PropTypes.bool,
  addStatus: PropTypes.bool,
  isBessSeletedDefault: PropTypes.bool,
  assetsType: PropTypes.array,
  manufacturerList: PropTypes.object,
  updatedAsset: PropTypes.object,
  onCloseAssetPopUp: PropTypes.func,
  onUpdateAsset: PropTypes.func,
  getAssetDetailsAttribute: PropTypes.func,
  projectTypes: PropTypes.array,
  assetAttributes: PropTypes.array,
  addAttributeToLibrary: PropTypes.func,
  handleAsset: PropTypes.func,
  handleAssetSelection: PropTypes.func,
  handleAssetAttribute: PropTypes.func,
  asset: PropTypes.object,
  handleEditAsset: PropTypes.func,
  handleOkEditAsset: PropTypes.func,
  handleCancelUpdateAsset: PropTypes.func,
  setIsExtendedLibrary: PropTypes.func,
  inputRefs: PropTypes.object,
  currentAvailableAttributes: PropTypes.array,
  isAssetTypeDisabled:PropTypes.bool
};

export default AddAsset;
